import { useProcessClinicalQAReports } from "../../hooks/useClinicalQA"
import Loader from "../../components/Loader"
import ApiError from "../../components/ApiError"
import { toast } from "sonner"

function ClinicalQA() {
  const {
    mutateAsync: process,
    isPending,
    isError,
    error,
  } = useProcessClinicalQAReports()

  const onStartProcess = async () => {
    try {
      await process()
      toast.success("Reports processed successfully.")
    } catch (error) {
      toast.error(
        "Something went wrong while processing the reports, please try again."
      )
    }
  }

  return (
    <div className="mt-8 p-8 md:p-12 bg-white rounded-xl shadow-lg flex flex-col items-center">
      <div className="md:w-3/4 flex flex-col items-center justify-center gap-8 pb-8">
        <div className="flex flex-col items-center gap-1">
          <h1 className="text-3xl font-bold text-primary">
            Clinical Quality Assurance
          </h1>
          <p className="text-sm text-gray-600 text-center">
            AI-Powered Analysis of Radiologist Reports
          </p>
        </div>

        <div className="transition duration-200 md:w-3/4 p-6 md:p-8 bg-gray-50 border-t-2 flex flex-col items-center justify-center gap-4">
          <p className="text-primary text-center">
            To start processing the reports, Please click the button below.
          </p>
          <button
            className="px-10 md:px-20 py-4 md:py-6 bg-primary text-white font-bold tracking-widest rounded-full flex justify-center items-center gap-2 md:text-lg disabled:bg-gray-500 disabled:opacity-80 disabled:cursor-not-allowed"
            disabled={isPending}
            onClick={onStartProcess}
          >
            {isPending ? (
              <Loader className="h-4 w-4 mb-0.5 mr-2" />
            ) : (
              <span className="material-icons-round">start</span>
            )}
            {isPending ? "Processing" : "Start Process"}
          </button>
        </div>

        {isError && <ApiError axiosError={error} />}
      </div>
    </div>
  )
}

export default ClinicalQA
